import { Observable } from "rxjs";
import { addNotification } from "../toaster/actions";
import { createErrorNotification, createSuccessNotification, } from "../toaster/creators";
export function createNotificationsEpic(ActionKeys, actionDescription, getId = (action) => action.config.name) {
    const errorMiddleware = (actions$) => actions$
        .ofType(ActionKeys.ERROR)
        .mergeMap((action) => Observable.of(addNotification(createErrorNotification(`cannot ${actionDescription} ${getId(action)} : ${action.payload}`, { showIcon: false }))));
    const finishMiddleware = (actions$) => actions$
        .ofType(ActionKeys.FINISH)
        .mergeMap((action) => Observable.of(addNotification(createSuccessNotification(`successfully ${actionDescription} : ${getId(action)}`, { showIcon: false }))));
    return [errorMiddleware, finishMiddleware];
}
//# sourceMappingURL=notifications.js.map